import React, {useState, useRef} from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import {InputText, handleCEPChange} from '@evag/ec-react';

import Button from 'src/components/Button';
import is from './inputs.module.scss';

const Material = ({values, onChange, onBlur, setFieldValue}) => {
  const [disabledLogradouro, setDisabledLogradouro] = useState(false);
  const refNumero = useRef(null);
  const refLogradouro = useRef(null);

  const props = (name) => ({name, value: values[name], onChange, onBlur});

  return (
    <>
      <p style={{textAlign: 'center'}}>
        Agora preencha seu endereço para receber materiais do mandato da Sâmia
        na sua casa.
      </p>

      <InputText
        className={is.text}
        cleave={{blocks: [5, 3], delimiter: '-', numericOnly: true}}
        placeholder="CEP"
        type="tel"
        {...{
          ...props('endCEP'),
          onChange: handleCEPChange(
            setDisabledLogradouro,
            setFieldValue,
            refNumero,
            refLogradouro,
            onChange
          ),
        }}
      />
      <InputText
        className={is.text}
        placeholder="Logradouro"
        disabled={disabledLogradouro}
        ref={refLogradouro}
        width="75%"
        {...props('endLogradouro')}
      />
      <InputText
        className={is.text}
        placeholder="Número"
        ref={refNumero}
        style={{marginLeft: '7%', width: '93%'}}
        type="tel"
        width="25%"
        {...props('endNumero')}
      />
      <InputText
        className={is.text}
        placeholder="Complemento"
        {...props('endComplemento')}
      />
      <InputText
        className={is.text}
        placeholder="Bairro"
        {...props('district')}
      />

      <input type="hidden" name="redirect" value={values.redirect} />
      <input type="hidden" name="subscribe" value={values.subscribe} />
      <Button type="submit" fontSize="16px" width="100%">
        Confirmar
      </Button>
    </>
  );
};

Material.propTypes = {
  values: PropTypes.object.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

Material.initialValues = {
  endCEP: '',
  endLogradouro: '',
  endNumero: '',
  endComplemento: '',
  district: '',
  material: true,
  subscribe: true,
  redirect: 'https://samiabomfim.com.br/ok/',
};

Material.validationSchema = Yup.object().shape({
  endCEP: Yup.string().required('O campo CEP é obrigatório.'),
  endLogradouro: Yup.string().required('O campo Logradouro é obrigatório.'),
  endNumero: Yup.string(),
  endComplemento: Yup.string(),
  district: Yup.string(),
});

Material.channelId = '407f98c8-bc24-4388-bb8c-595f574a2cb5';
Material.element = Material;
Material.captcha = true;
export default Material;
